import Link from "next/link";

export function LogoMark({
  light = false,
  href,
}: {
  light?: boolean;
  href?: string;
}) {
  const mark = (
    <span className="inline-flex items-center gap-2.5 font-extrabold tracking-tight">
      <span className="flex h-[34px] w-[34px] flex-none items-center justify-center rounded-[9px] bg-gradient-to-br from-teal to-navy3 text-[15px] font-extrabold text-white">
        42
      </span>
      <span className={`text-[19px] ${light ? "text-white" : "text-ink"}`}>
        42
        <b className={light ? "text-teal-bright" : "text-teal-deep"}>Voice</b>
      </span>
    </span>
  );

  if (href) {
    return (
      <Link href={href} aria-label="Go to dashboard" className="inline-flex">
        {mark}
      </Link>
    );
  }

  return <div className="inline-flex">{mark}</div>;
}
